module.exports = __webpack_public_path__ + "img/insufficient-balance-new.a0acd34.png";